import LeadForm from '@v4/lead-form/LeadForm';

export default LeadForm;
